import { render } from "./Preparation.vue?vue&type=template&id=043607af"
import script from "./Preparation.vue?vue&type=script&lang=js"
export * from "./Preparation.vue?vue&type=script&lang=js"

import "./Preparation.vue?vue&type=style&index=0&id=043607af&lang=less"
script.render = render

export default script